import {validateFilterOption} from "./FilterDataValidations";
import ApiFilter from "@milestoneslabs/milestones-js-engine/src/Api/ApiFilter";
import {store} from "../../index";
import AppResourceSearch from "@milestoneslabs/milestones-js-engine/src/Data/AppResourceSearch";
import {
    PENDING_AND_UNDER_CONTRACT,
    ACTIVE,
    NONE
} from "@milestoneslabs/milestones-core-js/src/AppResources/LuListingStatusAppResource";
import {SORT_FIELDS, SORT_TYPES} from "../../helpers/filterOptions";
import {isEmpty} from "lodash";

/**
 * Filter class used for requesting properties with a search filter
 */
class Filter {
    constructor() {
        this.initParams();
        this._location = null;
        this._orderBy = null;
    }

    /**
     * Set the filter params to their initial values
     */
    initParams() {
        if (
            performance.getEntriesByType("navigation")[0] &&
            performance.getEntriesByType("navigation")[0].type !== "reload"
        ) {
            localStorage.removeItem(this.getParameterByName("projectUuid"));
        }

        this._search = null;
        this._searchLabel = '';
        this._price = this.getLocalStorage('price') ? this.getLocalStorage('price') :
            {
                min: {
                    value: 0,
                    label: 'No Min',
                },
                max: {
                    value: null,
                    label: 'No Max',
                },
            };
        this._beds = this.getLocalStorage('beds') ? this.getLocalStorage('beds') :
            {
                value: null,
                label: null,
            };
        this._baths = this.getLocalStorage('baths') ? this.getLocalStorage('baths') :
            {
                value: null,
                label: null,
            };
        this._homeType = this.getLocalStorage('homeType') ? this.getLocalStorage('homeType'): [];
        this._sale = this.getLocalStorage('sale') ? this.getLocalStorage('sale') : [];
        this._favorite = this.getLocalStorage('favorite');
        this._squareFeet = this.getLocalStorage('squareFeet') ? this.getLocalStorage('squareFeet') :
            {
                min: {
                    value: 0,
                    label: 'No Min',
                },
                max: {
                    value: null,
                    label: 'No Max',
                },
            };
        this._lotSize = this.getLocalStorage('lotSize') ? this.getLocalStorage('lotSize') :
            {
                min: {
                    value: 0,
                    label: 'No Min',
                },
                max: {
                    value: null,
                    label: 'No Max',
                },
            };
        this._yearBuilt = this.getLocalStorage('yearBuilt') ? this.getLocalStorage('yearBuilt') :
            {
                min: {
                    value: 0,
                    label: 'No Min',
                },
                max: {
                    value: null,
                    label: 'No Max',
                },
            };
        this._keywords = this.getLocalStorage('keywords') ? this.getLocalStorage('keywords') : [];
        this._isSold = this.getLocalStorage('isSold') !== null ? this.getLocalStorage('isSold') : false;
        this._includePending =  this.getLocalStorage('includePending') !== null ? this.getLocalStorage('includePending') : false;
    }

    /**
     * @returns {null}
     */
    get search() {
        return this._search;
    }

    /**
     * @param value
     */
    set search(value) {
        this._search = value;
    }

    /**
     * @returns {null}
     */
    get location() {
        return this._location;
    }

    /**
     * @param value
     */
    set location(value) {
        this._location = value;
    }

    /**
     * @returns {null}
     */
    get searchLabel() {
        return this._searchLabel;
    }

    /**
     * @param value
     */
    set searchLabel(value) {
        this._searchLabel = value;
    }

    /**
     * @returns {null}
     */
    get price() {
        return this._price;
    }

    /**
     * @param value
     */
    set price(value) {
        this._price = value;
    }

    /**
     * @returns {null}
     */
    get beds() {
        return this._beds;
    }

    /**
     * @param value
     */
    set beds(value) {
        this._beds = value;
    }

    /**
     * @returns {null}
     */
    get baths() {
        return this._baths;
    }

    /**
     * @param value
     */
    set baths(value) {
        this._baths = value;
    }

    /**
     * @returns {null}
     */
    get squareFeet() {
        return this._squareFeet;
    }

    /**
     * @param value
     */
    set squareFeet(value) {
        this._squareFeet = value;
    }

    /**
     * @returns {null}
     */
    get lotSize() {
        return this._lotSize;
    }

    /**
     * @param value
     */
    set lotSize(value) {
        this._lotSize = value;
    }

    /**
     * @returns {null}
     */
    get yearBuilt() {
        return this._yearBuilt;
    }

    /**
     * @param value
     */
    set yearBuilt(value) {
        this._yearBuilt = value;
    }

    /**
     * @returns {null}
     */
    get homeType() {
        return this._homeType;
    }

    /**
     * @param value
     */
    set homeType(value) {
        this._homeType = value;
    }

    /**
     * @returns {null}
     */
    get sale() {
        return this._sale;
    }

    /**
     * @param value
     */
    set sale(value) {
        this._sale = value;
    }

    /**
     * @returns {null}
     */
    get favorite() {
        return this._favorite;
    }

    /**
     * @param value
     */
    set favorite(value) {
        this._favorite = value;
    }

    /**
     * @returns {null}
     */
    get orderBy() {
        return this._orderBy;
    }

    /**
     * @param value
     */
    set orderBy(value) {
        this._orderBy = value;
    }

    /**
     * @returns {null}
     */
    get keywords() {
        return this._keywords;
    }

    /**
     * @param value
     */
    set keywords(value) {
        this._keywords = value;
    }

    /**
     * @returns {boolean}
     */
    get isSold() {
        return this._isSold;
    }

    /**
     * @param value
     */
    set isSold(value) {
        this._isSold = value;
        this.sale = [];
    }

    /**
     * @returns {boolean}
     */
    get includePending() {
        return this._includePending;
    }

    /**
     * @param value
     */
    set includePending(value) {
        this._includePending = value;
    }

    /**
     * @param prop
     * @returns {null|any}
     */
    getLocalStorage(prop) {
        if (
            typeof (Storage) !== "undefined" &&
            JSON.parse(localStorage.getItem(this.getParameterByName("projectUuid"))) !== null
        ) {
            let projectFilters = JSON.parse(localStorage.getItem(this.getParameterByName("projectUuid")));

            if (projectFilters.hasOwnProperty(prop)) {
                return projectFilters[prop];
            }
        }

        return null;
    }

    /**
     * @returns ApiFilter
     */
    async buildRequestFilterData(importSource = null) {
        if (this._favorite) {
            const apiFilter = new ApiFilter({
                params: {
                    isFavorite: true,
                    workspaceUuid: store.getters.getWorkspaceUuid,
                }
            });

            return apiFilter;
        }

        const apiFilter = new ApiFilter({
            params: {
                importSource: importSource ? importSource : store.getters.getCurrentProjectMlsId,
            }
        });

        if (!this._isSold) {
            apiFilter.addParam('offMarketAt', {operator: "isNull", value: true});

            if (!this._includePending) {
                const hjListingStatusAppResourceSearch = new AppResourceSearch('home-junction-listing-status');

                const statusFilter = new ApiFilter({
                    params: {
                        lookupListingStatusUuid: {
                            operator: 'in',
                            value: [
                                NONE,
                                ACTIVE,
                            ]
                        },
                    }
                });

                hjListingStatusAppResourceSearch.setSearchData({
                    pagination: 'disabled',
                    filter: statusFilter,
                }, false);

                await hjListingStatusAppResourceSearch.search();

                if (hjListingStatusAppResourceSearch.appResourceCollection.isEmpty) {
                    return false;
                }

                const listingStatuses = hjListingStatusAppResourceSearch.appResourceCollection.toArray()
                    .map(item => item.status);
                apiFilter.addParam('status', {
                    operator: "in",
                    value: listingStatuses,
                });
            }
        }

        for (const [filterOption, filterValue] of Object.entries(this)) {
            if (
                typeof filterValue !== "boolean"
                && (isEmpty(filterValue) || filterValue === null)
            ) {
                continue;
            }
            if (typeof filterValue === "boolean" && (filterValue === undefined || filterValue === null)) {
                continue;
            }

            if (BEDS_OR_BATHS_OPTIONS.hasOwnProperty(filterOption)) {
                apiFilter.addParam(BEDS_OR_BATHS_OPTIONS[filterOption], {
                    from: this[filterOption].value ? this[filterOption].value : 1,
                });
            }
            if (filterOption === '_price') {
                let fromTo = {
                    from: filterValue.min.value,
                };
                if (filterValue.max.value) {
                    fromTo.to = filterValue.max.value;
                }
                apiFilter.addParam('price', fromTo);
            }
            if (filterOption === '_lotSize') {
                let fromTo = {
                    from: filterValue.min.value,
                };
                if (filterValue.max.value) {
                    fromTo.to = filterValue.max.value;
                }
                apiFilter.addParam('lotSize', fromTo);
            }
            if (filterOption === '_squareFeet') {
                let fromTo = {
                    from: filterValue.min.value,
                };
                if (filterValue.max.value) {
                    fromTo.to = filterValue.max.value;
                }
                apiFilter.addParam('size', fromTo);
            }
            if (filterOption === '_yearBuilt') {
                let fromTo = {
                    from: filterValue.min.value,
                };
                if (filterValue.max.value) {
                    fromTo.to = filterValue.max.value;
                }
                apiFilter.addParam('yearBuilt', fromTo);
            }
            if (filterOption === '_search') {
                apiFilter.addParam(filterValue.nested, {
                    operator: 'contains',
                    value: filterValue.value,
                });
            }
            if (filterOption === '_sale') {
                for (const homeType of filterValue) {
                    apiFilter.addParam(homeType.value.field, {
                        operator: homeType.value.operator,
                        value: homeType.value.fieldValue,
                    });
                }
            }
            if (filterOption === '_keywords') {
                apiFilter.addParam('details.description', {
                    operator: 'keywords',
                    value: filterValue,
                });
            }
            if (filterOption === '_homeType') {
                const HomeJunctionHomeTypeAppResourceSearch = new AppResourceSearch('home-junction-home-type');

                const homeTypeFilter = new ApiFilter({
                    params: {
                        lookupHomeTypeUuid: {
                            operator: 'in',
                            value: filterValue.map(item => item.value),
                        },
                    }
                });

                HomeJunctionHomeTypeAppResourceSearch.setSearchData({
                    pagination: 'disabled',
                    filter: homeTypeFilter,
                }, false);

                try {
                    await HomeJunctionHomeTypeAppResourceSearch.search();
                } catch (e) {
                    console.error(e);
                    return false;
                }


                if (HomeJunctionHomeTypeAppResourceSearch.appResourceCollection.isEmpty) {
                    return false;
                }

                const homeTypes = HomeJunctionHomeTypeAppResourceSearch.appResourceCollection.toArray()
                    .map(item => item.homeType);

                apiFilter.addParam('type', {
                    operator: "in",
                    value: homeTypes,
                });
            }
            if (filterOption === '_location' && Array.isArray(filterValue)) {
                apiFilter.addParam('location', filterValue);
            }
            if (filterOption === '_isSold') {
                apiFilter.addParam('isSold', filterValue);
            }
        }
        return apiFilter;
    }

    /**
     *
     */
    buildRequestOrderData() {
        if (!this._orderBy || this._favorite) {
            return {};
        }

        let orderBy;
        if (this._orderBy.type === SORT_TYPES.COLUMN) {
            orderBy = {};

            if(this.isSold && this._orderBy.value === "new_listings_descending") {
                orderBy['details.saleDate'] = this._orderBy.direction;
            } else {
                orderBy[this._orderBy.field] = this._orderBy.direction;
            }

        }

        if (this._orderBy.type === SORT_TYPES.COUNT) {
            orderBy = {count: {}};
            orderBy.count[this._orderBy.field + 'Count'] = this._orderBy.direction;
        }

        return orderBy;
    }

    /**
     *
     */
    buildRequestCountData() {
        if (!this._orderBy || (this._orderBy.type !== SORT_TYPES.COUNT)) {
            return null;
        }

        let relationFilter = new ApiFilter({
            params: {
                createdAt: {
                    operator: '!=',
                    value: null,
                }
            }
        });

        let countFilter = new ApiFilter({});
        countFilter.addRelation(this._orderBy.field, relationFilter);

        return countFilter;
    }

    /**
     * clear filter
     */
    clear(filterOption) {
        if (filterOption) {
            if (this[filterOption.filterOption] === undefined) {
                return;
            }
            if (typeof (Storage) !== "undefined") {
                localStorage.setItem(filterOption.filterOption.substr(1), null);
            }
            if (ARRAY_LIKE_OPTIONS.hasOwnProperty(filterOption.filterOption)) {
                const index = this[filterOption.filterOption].indexOf(filterOption.filterValue);
                this[filterOption.filterOption].splice(index, 1);
                return;
            }
            if (MIN_MAX_OPTIONS.hasOwnProperty(filterOption.filterOption)) {
                this[filterOption.filterOption] = {
                    min: {
                        value: 0,
                        label: 'No Min',
                    },
                    max: {
                        value: null,
                        label: 'No Max',
                    },
                };
                return;
            }
            if (filterOption.filterOption === '_includePending') {
                this[filterOption.filterOption] = false;
            }
            this[filterOption.filterOption] = {
                label: null,
                value: null,
            };
            return;
        }

        if (typeof (Storage) !== "undefined") {
            localStorage.removeItem(this.getParameterByName("projectUuid"));
        }

        this.initParams();
    }

    getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');

        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        let results = regex.exec(url);

        if (!results) {
            return null;
        }
        if (!results[2]) {
            return '';
        }

        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
}

export const BEDS_OR_BATHS_OPTIONS = Object.freeze({
    '_beds': 'bedrooms',
    '_baths': 'bathrooms',
});
export const ARRAY_LIKE_OPTIONS = Object.freeze({
    '_homeType': '_homeType',
    '_sale': '_sale',
    '_keywords': '_keywords',
});
export const MIN_MAX_OPTIONS = Object.freeze({
    '_price': 'PRICES',
    '_squareFeet': 'SQUARE_FEET',
    '_lotSize': 'LOT_SIZE',
    '_yearBuilt': 'YEAR_BUILT',
});
export const BOOLEAN_OPTIONS = Object.freeze({
    '_isSold': '_isSold',
});

/**
 * Set handler for proxy class to allow only specified filter options as object properties
 * @type {{set(*, *=, *): boolean}}
 */
const setFilterOptionHandler = {
    set(target, prop, value) {
        validateFilterOption(prop, true);

        let localStorageObj = {};
        if (localStorage.getItem(store.getters.getWorkspaceUuid) !== null) {
            localStorageObj = JSON.parse(localStorage.getItem(store.getters.getWorkspaceUuid));
        }

        if (!(typeof prop === 'string' && prop.startsWith('_'))) {
            if (typeof(Storage) !== "undefined") {
                localStorageObj[prop.toString()] = value;

                localStorage.setItem(
                    store.getters.getWorkspaceUuid,
                    JSON.stringify(localStorageObj)
                );
            }
            return Reflect.set(...arguments);
        }

        target[prop.substr(1)] = value;
        return true;
    },
};

const filter = new Filter();
filter.orderBy = SORT_FIELDS.find(
    (field) => field.value === 'new_listings_descending'
);

/**
 * Proxy class for Filter
 * @type {Filter}
 */
const proxyFilter = new Proxy(filter, setFilterOptionHandler);

export {proxyFilter};
